import React from 'react';

import colors from '@constants/colors';

import styles from './PercentSpinner.module.scss';

const OFFSET = 10;

interface IPercentSpinnerProps {
	percent: number;
	strokeWidth?: number;
	width?: number;
}

const PercentSpinner = ({
	percent = 0,
	strokeWidth = 8,
	width = 50,
}: IPercentSpinnerProps) => {
	const radius = width / 2;
	const circumference = 2 * Math.PI * radius;
	const strokeDashoffset = circumference - (circumference * percent / 100);
	const svgSize = `${width + OFFSET}px`;

	return (
		<div
			className={styles.percentSpinnerContainer}
		>
			<svg
				height={svgSize}
				width={svgSize}
			>
				<circle cx={radius}
						cy={radius}
						fill='none'
						height={`${width}px`}
						r={radius}
						stroke={colors.indigo10}
						strokeDasharray={circumference}
						strokeDashoffset={0}
						strokeWidth={strokeWidth}
						width={`${width}px`}
				/>
				<circle cx={radius}
						cy={radius}
						fill='none'
						height={`${width}px`}
						r={radius}
						stroke={colors.indigo60}
						strokeDasharray={circumference}
						strokeDashoffset={strokeDashoffset}
						strokeWidth={strokeWidth}
						width={`${width}px`}
				/>
				<circle />
			</svg>
		</div>
	);
};

export default PercentSpinner;
